// extracted by mini-css-extract-plugin
export var drawerPaper = "_30-0";
export var itemCard = "_30-1";
export var itemImage = "_30-2";